import IconLine from "../../../public/images/line.svg";
import Field from "../../Field";
import {useRef} from "react";
import ArrowButtonInput from "../buttons/ArrowButtonInput";
import {fontLineVariants} from "../../../utils/consts";
import useObjectEditStore from "../../../store/useObjectEditStore";
import IconArrow from "../../../public/images/arrow-down-mini.svg";
import {useOutsideClick} from "../../../hooks/useOutsideClick";
import {decrement} from "../../../utils/decrement";
import {increment} from "../../../utils/increment";
import PropTypes from "prop-types";

const LineSelect = () => {
  const objectEditStore = useObjectEditStore();

  const selectRef = useRef(null);
  useOutsideClick(selectRef, {
    onExternalClick: () => {
      if(objectEditStore.isOpenLineSelect)
      {
        objectEditStore.setIsOpenLineSelect(false)
      }
    },
    onInternalClick: () => {return},
  });

  return (
    <div className="select__block" ref={selectRef}>
      <button className="select" onClick={() => {
        objectEditStore.setIsOpenLineSelect(!objectEditStore.isOpenLineSelect)
      }}>
        <IconLine className="select__icon"/>
        <IconArrow className={`select__icon-arrow ${objectEditStore.isOpenLineSelect ? "select__icon-arrow-active" : ""}`}/>
      </button>
      <ListComponent variants={fontLineVariants}/>
    </div>
  );
};

const ListComponent = ({variants} ) => {
  const objectEditStore = useObjectEditStore();
  const inputRef = useRef(null);

  return (
    <ul
      className={`select__list ${!objectEditStore.isOpenLineSelect ? 'select__list-hide' : ''}`}>
      <div className="select__input-block">
        <Field.Input
          type="number" value={objectEditStore.fontLine} ref={inputRef}
          onChange={(event) => objectEditStore.setFontLine(event.target.value)}
          onClick={(event) => event.stopPropagation()}
          min="1" max="50" autoComplete="off"
          className="select__input"
        />
        <ArrowButtonInput onClick={() => objectEditStore.setFontLine(decrement({ref: inputRef}))} isBottom={false}/>
        <ArrowButtonInput onClick={() => objectEditStore.setFontLine(increment({ref: inputRef}))} isBottom={true}/>
      </div>
      {variants.map(variant =>
        <li key={variant} value={variant}
            className={`select__variant ${variant === objectEditStore.fontLine ? 'select__variant-active' : ''} select__variant-size`}
            onClick={() => objectEditStore.setFontLine(variant)}>
          {variant}
        </li>
      )}
    </ul>
)}

ListComponent.propTypes = {
  variants: PropTypes.array,
};

export default LineSelect;
